export const translations = {
  pt: {
    nav: {
      home: "Início",
      about: "Sobre",
      solutions: "Soluções",
      sectors: "Setores",
      projects: "Projetos & Experiência",
      insights: "Insights",
      contact: "Contato",
      contactCta: "Fale com um especialista",
    },
    home: {
      eyebrow: "CONSULTORIA ESTRATÉGICA EM ENGENHARIA",
      heroTitle: "Gestão estratégica para programas e projetos de alto impacto.",
      heroSubtitle:
        "Utilizamos uma visão global para a estruturação do planejamento e gestão de performance de programas e projetos de grande porte.",
      heroCta1: "Fale com um especialista",
      heroCta2: "Conheça nossas soluções",

      strategicEyebrow: "ATUAÇÃO ESTRATÉGICA",
      strategicTitle: "Integrando engenharia, mercado e regulação.",
      strategicBody:
        "Atuamos na interseção entre engenharia, dinâmica de mercado, regulação e viabilidade econômico-financeira. Estruturamos programas e projetos de grande porte com visão sistêmica, governança desde a origem e alinhamento institucional entre os diferentes stakeholders — investidores, órgãos reguladores, financiadores e operadores através de advisory estratégico de longo prazo.",

      pillarsEyebrow: "NOSSA ESTRUTURA DE ATUAÇÃO",
      pillarsTitle: "Quatro pilares de integração.",
      pillars: [
        {
          n: "01",
          title: "Estruturação e Modelagem Técnica e Econômica de Projetos e Operações",
          text:
            "Definição de escopo, configuração técnica, análise de engenharia conceitual e estruturação de arquiteturas de projeto robustas, alinhadas à estratégia do empreendedor e às exigências do mercado.",
        },
        {
          n: "02",
          title: "Inteligência Regulatória e Interface Institucional",
          text:
            "Mapeamento de marcos regulatórios, articulação com órgãos competentes, gestão de licenciamento, outorgas e instrumentos institucionais que sustentam a bancabilidade do projeto.",
        },
        {
          n: "03",
          title: "Governança e Gestão Estratégica de Programas (PMO)",
          text:
            "Implantação de PMO estratégico, governança de programas multi-projeto, controle de portfólio, gestão de interfaces e monitoramento de performance ao longo de todo o ciclo de vida.",
        },
        {
          n: "04",
          title: "Viabilidade Econômico-Financeira e Análise de Riscos",
          text:
            "Modelagem econômico-financeira, análise de sensibilidade, estruturação de cenários, avaliação de matriz de riscos e suporte à estruturação de financiamento e instrumentos de capital.",
        },
      ],

      sectorsEyebrow: "SETORES DE ATUAÇÃO",
      sectorsTitle: "Onde criamos valor estratégico.",
      sectors: [
        {
          title: "Energias Renováveis",
          text:
            "Estruturação de projetos solares, eólicos onshore e offshore, biomassa e soluções híbridas, com foco em competitividade de longo prazo.",
        },
        {
          title: "Hidrogênio e Derivados Energéticos",
          text:
            "Modelagem técnico-econômica de hidrogênio de baixo carbono, amônia verde e derivados, considerando cadeias de exportação e demanda industrial.",
        },
        {
          title: "Mercados de Carbono e Ativos Ambientais",
          text:
            "Estruturação de projetos elegíveis, análise metodológica, estratégias de monetização e posicionamento em mercados regulados e voluntários.",
        },
        {
          title: "Infraestrutura Estratégica",
          text:
            "Programas de infraestrutura de energia, logística e transição energética, com foco em bancabilidade, governança e alinhamento institucional.",
        },
      ],

      projectsEyebrow: "PROJETOS & EXPERIÊNCIA",
      projectsTitle: "Atuação em programas de alta complexidade.",
      projectsBody:
        "Nossa atuação se concentra em programas e projetos de alta complexidade técnica, regulatória e econômica. Acompanhamos iniciativas desde a concepção estratégica até a estruturação final para investimento, aplicando governança rigorosa, arquitetura contratual consistente e disciplina de execução. Priorizamos a mitigação de riscos estruturais, a consistência da modelagem financeira e o alinhamento institucional dos diferentes agentes envolvidos, com absoluta discrição no tratamento das informações dos clientes.",

      diffEyebrow: "DIFERENCIAIS ESTRATÉGICOS",
      diffTitle: "Uma consultoria estruturada para programas de longo prazo.",
      diffs: [
        {
          title: "Abordagem sistêmica",
          text: "Leitura integrada dos vetores técnicos, regulatórios, institucionais e financeiros que definem o êxito do programa.",
        },
        {
          title: "Integração técnico-regulatória-financeira",
          text: "Tradução coerente entre engenharia, marco regulatório e modelagem econômico-financeira em uma única arquitetura de decisão.",
        },
        {
          title: "Governança desde a origem",
          text: "Desenho de estrutura de governança, controles e PMO implantados desde a concepção do programa, não como resposta tardia.",
        },
        {
          title: "Alinhamento estratégico de stakeholders",
          text: "Articulação institucional entre investidores, reguladores, financiadores e operadores em torno de um racional comum.",
        },
      ],

      aboutEyebrow: "SOBRE A SYNERGIA",
      aboutTitle: "Estruturação, governança e valor de longo prazo.",
      aboutBody:
        "A SYNERGIA é uma consultoria estratégica em engenharia dedicada à estruturação e gestão de programas e projetos de alto impacto. Atuamos como um integrador técnico-regulatório-financeiro, com foco em governança, mitigação de riscos estruturais e geração de valor econômico de longo prazo. Nosso posicionamento é institucional, independente e orientado à disciplina estratégica — servindo empreendedores, investidores e instituições que operam em setores decisivos para a transição energética e a infraestrutura do país.",

      finalTitle: "Estruture seu próximo programa com inteligência estratégica.",
      finalBody:
        "Conecte-se com nossa equipe para discutir o posicionamento estratégico, a arquitetura regulatória e a viabilidade econômico-financeira do seu próximo programa.",
      finalCta: "Fale com um especialista",
    },
    about: {
      eyebrow: "SOBRE A SYNERGIA",
      title: "Uma consultoria estratégica em engenharia.",
      intro:
        "A SYNERGIA atua na estruturação e gestão de programas e projetos de alto impacto. Integramos visão técnica, regulatória e financeira em uma arquitetura única de decisão, orientada por governança, disciplina estratégica e geração de valor de longo prazo.",
      sections: [
        {
          title: "Missão",
          text:
            "Estruturar programas e projetos de grande porte com rigor técnico, consistência regulatória e robustez econômico-financeira, apoiando empreendedores, investidores e instituições em decisões de longo prazo.",
        },
        {
          title: "Posicionamento",
          text:
            "Atuamos como integrador técnico-regulatório-financeiro. Não somos uma empresa de execução, EPC ou instalação. Nosso papel é o advisory estratégico, a estruturação de projetos e a governança.",
        },
        {
          title: "Princípios",
          text:
            "Independência técnica, visão sistêmica, governança desde a origem, disciplina analítica e absoluta confidencialidade na relação com os clientes.",
        },
      ],
    },
    solutions: {
      eyebrow: "SOLUÇÕES",
      title: "Quatro frentes integradas de atuação.",
      intro:
        "Nossas soluções são articuladas como um sistema. Cada frente conecta-se às demais para sustentar decisões estruturais ao longo do ciclo de vida do programa.",
    },
    sectors: {
      eyebrow: "SETORES",
      title: "Setores estratégicos de atuação.",
      intro:
        "Atuamos em setores estruturantes da transição energética e da infraestrutura estratégica, com profundidade técnica, regulatória e econômica.",
    },
    projects: {
      eyebrow: "PROJETOS & EXPERIÊNCIA",
      title: "Atuação em programas de alta complexidade.",
      intro:
        "Nossa experiência é construída na condução de programas e projetos estruturantes, com governança rigorosa, análise de riscos aprofundada e disciplina financeira. Respeitamos a confidencialidade absoluta dos nossos clientes; nossa comunicação é feita pela consistência dos processos, não pelo nome dos envolvidos.",
      blocks: [
        {
          title: "Programas estruturantes de energia",
          text:
            "Condução da estruturação estratégica, regulatória e financeira de programas envolvendo múltiplos ativos de geração, com foco em bancabilidade e escala.",
        },
        {
          title: "Projetos de hidrogênio e derivados",
          text:
            "Estruturação de arquiteturas técnico-comerciais para produção de hidrogênio de baixo carbono e derivados, considerando cadeias de exportação e offtake industrial.",
        },
        {
          title: "Mercados de carbono e ativos ambientais",
          text:
            "Análise metodológica, estruturação de projetos elegíveis e estratégias de monetização em mercados regulados e voluntários.",
        },
        {
          title: "Infraestrutura estratégica",
          text:
            "Programas de infraestrutura vinculados à transição energética, com governança multi-stakeholder e interface institucional robusta.",
        },
      ],
    },
    insights: {
      eyebrow: "INSIGHTS",
      title: "Perspectivas técnicas e institucionais.",
      intro:
        "Publicações institucionais sobre estruturação de programas, regulação, viabilidade financeira e governança em setores estratégicos.",
      linkedinLabel: "Acompanhe as publicações no LinkedIn",
      readMore: "Ler análise",
      articles: [
        {
          date: "2026",
          category: "HIDROGÊNIO",
          title: "Arquitetura de bancabilidade para projetos de hidrogênio de baixo carbono.",
          excerpt:
            "Um olhar estrutural sobre os vetores técnicos, regulatórios e contratuais que sustentam a viabilidade econômico-financeira de programas de hidrogênio no cenário brasileiro.",
        },
        {
          date: "2026",
          category: "MERCADOS DE CARBONO",
          title: "Regulação, metodologia e integridade em mercados de carbono.",
          excerpt:
            "Como a convergência entre marco regulatório, consistência metodológica e governança corporativa redefine a qualidade dos ativos ambientais em projetos de grande porte.",
        },
        {
          date: "2025",
          category: "ENERGIAS RENOVÁVEIS",
          title: "Governança de portfólio em programas multi-ativos de geração renovável.",
          excerpt:
            "A prática de um PMO estratégico como condição estrutural para a execução disciplinada de programas com múltiplos ativos, contratos e interfaces institucionais.",
        },
        {
          date: "2025",
          category: "INFRAESTRUTURA",
          title: "Estruturação institucional em programas de infraestrutura estratégica.",
          excerpt:
            "Entre o desenho de projeto e a decisão de investimento, a arquitetura institucional é frequentemente subestimada — e determina o êxito de longo prazo do programa.",
        },
      ],
    },
    contact: {
      eyebrow: "CONTATO",
      title: "Fale com um especialista.",
      intro:
        "Entre em contato para uma conversa institucional sobre a estruturação, a governança ou a viabilidade econômico-financeira do seu programa.",
      labels: {
        name: "Nome",
        email: "E-mail corporativo",
        company: "Empresa",
        phone: "Telefone",
        sector: "Setor de interesse",
        message: "Mensagem",
        submit: "Enviar contato",
        sending: "Enviando...",
        success: "Mensagem enviada. Nossa equipe retornará em breve.",
        error: "Não foi possível enviar. Tente novamente em instantes.",
        chooseSector: "Selecione um setor",
      },
      officeLabel: "Contato institucional",
      officeEmail: "contato@synergiaengenharia.com.br",
    },
    footer: {
      tagline:
        "Consultoria estratégica em engenharia para programas e projetos de alto impacto.",
      navigation: "Navegação",
      sectors: "Setores",
      contact: "Contato",
      rights: "Todos os direitos reservados.",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      solutions: "Solutions",
      sectors: "Sectors",
      projects: "Projects & Experience",
      insights: "Insights",
      contact: "Contact",
      contactCta: "Talk to a specialist",
    },
    home: {
      eyebrow: "STRATEGIC ENGINEERING CONSULTING",
      heroTitle: "Strategic management for high-impact programs and projects.",
      heroSubtitle:
        "We apply a global perspective to structure planning and performance management of large-scale programs and projects.",
      heroCta1: "Talk to a specialist",
      heroCta2: "Explore our solutions",

      strategicEyebrow: "STRATEGIC APPROACH",
      strategicTitle: "Engineering, markets and regulation, integrated.",
      strategicBody:
        "We operate at the intersection of engineering, market dynamics, regulation and financial viability. We structure large-scale programs and projects with a systemic view, governance from the outset and institutional alignment across stakeholders — investors, regulators, financiers and operators through long-term strategic advisory.",

      pillarsEyebrow: "OUR FRAMEWORK",
      pillarsTitle: "Four integrated pillars.",
      pillars: [
        {
          n: "01",
          title: "Technical and Economic Structuring and Modeling of Projects and Operations",
          text:
            "Scope definition, technical configuration, conceptual engineering analysis and robust project architectures aligned with strategy and market requirements.",
        },
        {
          n: "02",
          title: "Regulatory Intelligence and Institutional Interface",
          text:
            "Mapping of regulatory frameworks, dialogue with competent authorities, licensing, concessions and institutional instruments that sustain bankability.",
        },
        {
          n: "03",
          title: "Governance and Strategic Program Management (PMO)",
          text:
            "Strategic PMO deployment, multi-project program governance, portfolio oversight, interface management and performance monitoring across the full lifecycle.",
        },
        {
          n: "04",
          title: "Financial Viability and Risk Analysis",
          text:
            "Economic-financial modeling, sensitivity analysis, scenario structuring, risk matrix assessment and support in financing and capital structuring.",
        },
      ],

      sectorsEyebrow: "SECTORS",
      sectorsTitle: "Where we create strategic value.",
      sectors: [
        {
          title: "Renewable Energy",
          text:
            "Structuring of solar, onshore and offshore wind, biomass and hybrid projects, with a focus on long-term competitiveness.",
        },
        {
          title: "Hydrogen and Energy Derivatives",
          text:
            "Technical-economic modeling of low-carbon hydrogen, green ammonia and derivatives, considering export chains and industrial demand.",
        },
        {
          title: "Carbon Markets and Environmental Assets",
          text:
            "Eligibility structuring, methodological analysis, monetization strategies and positioning in regulated and voluntary markets.",
        },
        {
          title: "Strategic Infrastructure",
          text:
            "Energy, logistics and energy transition infrastructure programs, focused on bankability, governance and institutional alignment.",
        },
      ],

      projectsEyebrow: "PROJECTS & EXPERIENCE",
      projectsTitle: "Highly complex programs.",
      projectsBody:
        "Our practice focuses on programs and projects of high technical, regulatory and economic complexity. We support initiatives from strategic inception through to final structuring for investment, with rigorous governance, consistent contractual architecture and execution discipline. We prioritize the mitigation of structural risks, consistency of financial modeling and institutional alignment among stakeholders, under strict client confidentiality.",

      diffEyebrow: "STRATEGIC DIFFERENTIATORS",
      diffTitle: "A consultancy built for long-term programs.",
      diffs: [
        {
          title: "Systemic approach",
          text:
            "Integrated reading of the technical, regulatory, institutional and financial vectors that determine a program's success.",
        },
        {
          title: "Technical-regulatory-financial integration",
          text:
            "Coherent translation between engineering, regulation and financial modeling into a single decision architecture.",
        },
        {
          title: "Governance from the outset",
          text:
            "Governance structures, controls and PMO deployed from inception, not as a late response to complexity.",
        },
        {
          title: "Stakeholder alignment",
          text:
            "Institutional articulation of investors, regulators, financiers and operators around a shared strategic rationale.",
        },
      ],

      aboutEyebrow: "ABOUT SYNERGIA",
      aboutTitle: "Structuring, governance and long-term value.",
      aboutBody:
        "SYNERGIA is a strategic engineering consultancy dedicated to the structuring and management of high-impact programs and projects. We operate as a technical-regulatory-financial integrator, focused on governance, mitigation of structural risks and creation of long-term economic value. Our positioning is institutional, independent and strategically disciplined — serving developers, investors and institutions operating in decisive sectors of the energy transition and strategic infrastructure.",

      finalTitle: "Structure your next program with strategic intelligence.",
      finalBody:
        "Connect with our team to discuss the strategic positioning, regulatory architecture and financial viability of your next program.",
      finalCta: "Talk to a specialist",
    },
    about: {
      eyebrow: "ABOUT SYNERGIA",
      title: "A strategic engineering consultancy.",
      intro:
        "SYNERGIA structures and manages high-impact programs and projects. We integrate technical, regulatory and financial vision into a single decision architecture, guided by governance, strategic discipline and long-term value creation.",
      sections: [
        {
          title: "Mission",
          text:
            "To structure large-scale programs and projects with technical rigor, regulatory consistency and financial robustness, supporting developers, investors and institutions in long-term decisions.",
        },
        {
          title: "Positioning",
          text:
            "We act as a technical-regulatory-financial integrator. We are not an EPC or execution firm. Our role is strategic advisory, project structuring and governance.",
        },
        {
          title: "Principles",
          text:
            "Technical independence, systemic perspective, governance from inception, analytical discipline and absolute client confidentiality.",
        },
      ],
    },
    solutions: {
      eyebrow: "SOLUTIONS",
      title: "Four integrated areas of practice.",
      intro:
        "Our solutions operate as a system. Each area connects with the others to sustain structural decisions across the program lifecycle.",
    },
    sectors: {
      eyebrow: "SECTORS",
      title: "Strategic sectors of practice.",
      intro:
        "We operate in structural sectors of the energy transition and strategic infrastructure, combining technical, regulatory and economic depth.",
    },
    projects: {
      eyebrow: "PROJECTS & EXPERIENCE",
      title: "Highly complex programs.",
      intro:
        "Our experience is built on leading structural programs and projects, with rigorous governance, in-depth risk analysis and financial discipline. We preserve absolute client confidentiality; we communicate through process consistency, not client names.",
      blocks: [
        {
          title: "Structural energy programs",
          text:
            "Strategic, regulatory and financial structuring of programs involving multiple generation assets, focused on bankability and scale.",
        },
        {
          title: "Hydrogen and derivatives",
          text:
            "Technical-commercial structuring of low-carbon hydrogen and derivatives, considering export chains and industrial offtake.",
        },
        {
          title: "Carbon markets and environmental assets",
          text:
            "Methodological analysis, eligible project structuring and monetization strategies in regulated and voluntary markets.",
        },
        {
          title: "Strategic infrastructure",
          text:
            "Energy transition-linked infrastructure programs, with multi-stakeholder governance and robust institutional interfaces.",
        },
      ],
    },
    insights: {
      eyebrow: "INSIGHTS",
      title: "Technical and institutional perspectives.",
      intro:
        "Institutional publications on program structuring, regulation, financial viability and governance in strategic sectors.",
      linkedinLabel: "Follow our publications on LinkedIn",
      readMore: "Read analysis",
      articles: [
        {
          date: "2026",
          category: "HYDROGEN",
          title: "Bankability architecture for low-carbon hydrogen projects.",
          excerpt:
            "A structural view of the technical, regulatory and contractual vectors that sustain the financial viability of hydrogen programs in the Brazilian scenario.",
        },
        {
          date: "2026",
          category: "CARBON MARKETS",
          title: "Regulation, methodology and integrity in carbon markets.",
          excerpt:
            "How the convergence of regulation, methodological consistency and corporate governance redefines the quality of environmental assets in large-scale projects.",
        },
        {
          date: "2025",
          category: "RENEWABLE ENERGY",
          title: "Portfolio governance in multi-asset renewable programs.",
          excerpt:
            "The practice of a strategic PMO as a structural condition for disciplined execution of programs with multiple assets, contracts and institutional interfaces.",
        },
        {
          date: "2025",
          category: "INFRASTRUCTURE",
          title: "Institutional structuring in strategic infrastructure programs.",
          excerpt:
            "Between project design and investment decision, institutional architecture is often underestimated — and determines the long-term success of the program.",
        },
      ],
    },
    contact: {
      eyebrow: "CONTACT",
      title: "Talk to a specialist.",
      intro:
        "Reach out for an institutional conversation about the structuring, governance or financial viability of your program.",
      labels: {
        name: "Name",
        email: "Corporate email",
        company: "Company",
        phone: "Phone",
        sector: "Sector of interest",
        message: "Message",
        submit: "Send message",
        sending: "Sending...",
        success: "Message sent. Our team will be in touch shortly.",
        error: "Unable to send. Please try again shortly.",
        chooseSector: "Select a sector",
      },
      officeLabel: "Institutional contact",
      officeEmail: "contato@synergiaengenharia.com.br",
    },
    footer: {
      tagline:
        "Strategic engineering consulting for high-impact programs and projects.",
      navigation: "Navigation",
      sectors: "Sectors",
      contact: "Contact",
      rights: "All rights reserved.",
    },
  },
};
